import { jsx as _jsx } from "react/jsx-runtime";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { Tooltip } from "./Tooltip";
export const IconWithTooltip = ({ icon, className, ...props }) => {
    return (_jsx(Tooltip, { offset: 8, interactive: true, ...props, children: _jsx(Icon, { icon: icon || faInfoCircle, className: className }) }));
};
const Icon = styled(FontAwesomeIcon) `
  color: ${(p) => p.theme.systemColors.grey600};
  font-size: 16px;
  width: 16px;
  height: 16px;
`;
